export const VaporDropHalo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="374"
    height="242"
    viewBox="0 0 374 242"
    fill="none"
  >
    <g filter="url(#filter0_f_1_8166)">
      <ellipse
        cx="87"
        cy="21"
        rx="87"
        ry="21"
        transform="matrix(1 0 0 -1 100 142)"
        fill="#443AFF"
        fill-opacity="0.4"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1_8166"
        x="0"
        y="0"
        width="374"
        height="242"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="50"
          result="effect1_foregroundBlur_1_8166"
        />
      </filter>
    </defs>
  </svg>
);
